import { sendBeacon } from "@source-digital/experience-utils";
function urlsPixelPlugin(config) {
  let loaded = false;
  function track(data) {
    var _a, _b, _c;
    const { event } = data.payload;
    (_c = (_b = (_a = config.getUrlPixelConfig()) == null ? void 0 : _a.events) == null ? void 0 : _b[event]) == null ? void 0 : _c.forEach((item) => {
      sendBeacon(item);
    });
  }
  return {
    name: "external-pixel-urls",
    initialize: () => {
      var _a;
      loaded = true;
      (_a = config.logger) == null ? void 0 : _a.call(config, "external pixel analytics enabled");
    },
    config,
    page: () => {
    },
    track,
    identify: () => {
    },
    loaded: () => {
      return loaded;
    }
  };
}
export {
  urlsPixelPlugin
};
